export type PasswordPolicyRuleId =
  | 'minLength'
  | 'number'
  | 'special'
  | 'uppercase'
  | 'lowercase';

export type PasswordPolicyRule = {
  id: PasswordPolicyRuleId;
  test: (value: string) => boolean;
  label: string;
};

export const DefaultPasswordPolicyMessages = {
  minLength: 'At least 8 characters',
  number: 'Contains at least 1 number',
  special: 'Contains at least 1 special character',
  uppercase: 'Contains at least 1 uppercase letter',
  lowercase: 'Contains at least 1 lowercase letter',
} as const;

export type PasswordPolicyMessages = Record<PasswordPolicyRuleId, string>;

export const PasswordPolicyRules: readonly PasswordPolicyRule[] = [
  {
    id: 'minLength',
    test: (value: string) => value.length >= 8,
    label: DefaultPasswordPolicyMessages.minLength,
  },
  {
    id: 'number',
    test: (value: string) => /\d/u.test(value),
    label: DefaultPasswordPolicyMessages.number,
  },
  {
    id: 'special',
    test: (value: string) => /[^A-Za-z0-9]/u.test(value),
    label: DefaultPasswordPolicyMessages.special,
  },
  {
    id: 'uppercase',
    test: (value: string) => /[A-Z]/u.test(value),
    label: DefaultPasswordPolicyMessages.uppercase,
  },
  {
    id: 'lowercase',
    test: (value: string) => /[a-z]/u.test(value),
    label: DefaultPasswordPolicyMessages.lowercase,
  },
] as const;
